import type { ServiceProvider, ServiceContainer } from "../service-container";
import type { OutputViewportStrategiesPool } from "./OutputViewportStrategiesPool";
import { BasePool } from "../pool";
import { UserProvidedViewport } from "./UserProvidedViewport";
import { BestFitViewport } from "./BestFitViewport";
import { SourceImageViewport } from "./SourceImageViewport";
import { BaseOutputViewportResolver } from "./BaseOutputViewportResolver";

/**
 * Output viewport resolution service provider.
 * @internal
 */
export const outputViewportStrategyProvider: ServiceProvider = {
  /**
   * Registers entities, related to output viewport resolution, in service container.
   *
   * @param container
   */
  register(container: ServiceContainer) {
    const pool: OutputViewportStrategiesPool = new BasePool();
    pool.add("user-provided", new UserProvidedViewport());
    pool.add("best-fit", new BestFitViewport());
    pool.add("source-image", new SourceImageViewport());
    container.register("OutputViewportStrategiesPool", pool);

    container.register("OutputViewportResolver", (c) => {
      return new BaseOutputViewportResolver(
        c.resolve("OutputViewportStrategiesPool")
      );
    });
  },
};
